import type { CompanyAccountOption, ReceiptChannel } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listCompanyAccountOptions } from '../company-accounts.api';

export type CompanyAccountOptionsState =
  { status: 'idle' } | { status: 'loading' } | { status: 'loaded'; options: CompanyAccountOption[] } | { status: 'error' };

/** The active accounts a channel can be paid into, fetched whole (a company has a handful) whenever the channel changes. `idle` until a channel is chosen. */
export function useCompanyAccountOptions(channel: ReceiptChannel | undefined): CompanyAccountOptionsState {
  const [loaded, setLoaded] = useState<{ channel: ReceiptChannel; state: CompanyAccountOptionsState } | null>(null);

  useEffect(() => {
    if (!channel) return;
    let cancelled = false;
    listCompanyAccountOptions(channel)
      .then((options) => !cancelled && setLoaded({ channel, state: { status: 'loaded', options } }))
      .catch(() => !cancelled && setLoaded({ channel, state: { status: 'error' } }));
    return () => {
      cancelled = true;
    };
  }, [channel]);

  if (!channel) return { status: 'idle' };
  return loaded?.channel === channel ? loaded.state : { status: 'loading' };
}
